module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.29b882f.woff";